import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font
} from '@react-pdf/renderer';

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
  },
  header: {
    borderBottom: "2 solid black",
    paddingBottom: 8,
    marginBottom: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  outletInfo: {
    flex: 1,
    alignItems: 'flex-end',
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    border: "1 solid gray",
    fontWeight: "bold",
    textAlign: "center",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1 solid gray",
    textAlign: "center",
  },
  column: (width) => ({
    width,
    padding: 4,
    borderRight: "1 solid gray",
  }),
  grandTotalRow: {
    flexDirection: "row",
    borderTop: "2 solid black",
    fontWeight: "bold",
    marginTop: 6,
    backgroundColor: "#e5e7eb",
  },
});

const SalesQuantityReportPDFDocumentForDownload = ({
  salesDetails,
  grandNetTotal,
  grandNetTotalQuantity,
  userInfo,
  formData,
}) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View>
            <Text style={{ fontWeight: "bold", fontSize: 12 }}>
              Sales Quantity Report
            </Text>
            <Text>{`${new Date(formData.start_date).toLocaleDateString(
              "en-GB"
            )} to ${new Date(formData.end_date).toLocaleDateString("en-GB")}`}</Text>
          </View>
          <View style={styles.outletInfo}>
            <Text style={{ fontWeight: "bold", fontSize: 10 }}>
              {userInfo?.outlet_name}
            </Text>
            <Text>{userInfo?.address}</Text>
            <Text>Mobile- {userInfo?.phone}</Text>
          </View>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={styles.column("40%")}>Product</Text>
          <Text style={styles.column("20%")}>Price</Text>
          <Text style={styles.column("20%")}>Quantity</Text>
          <Text style={styles.column("20%")}>Sales Amount</Text>
        </View>

        {/* Table Rows */}
        {salesDetails.map((detail, index) => (
          <View key={index} style={styles.tableRow}>
            <Text style={styles.column("40%")}>
              {detail?.product_info?.name || "N/A"}
            </Text>
            <Text style={styles.column("20%")}>{detail?.single_price}</Text>
            <Text style={styles.column("20%")}>{detail?.qty_sum}</Text>
            <Text style={styles.column("20%")}>{detail?.price_sum}</Text>
          </View>
        ))}

        {/* Grand Total Quantity */}
        <View style={styles.grandTotalRow}>
          <Text style={styles.column("60%")}>Grand Total Quantity</Text>
          <Text style={{ ...styles.column("40%"), textAlign: "right" }}>{grandNetTotalQuantity}</Text>
        </View>

        {/* Grand Total Sales */}
        <View style={styles.grandTotalRow}>
          <Text style={styles.column("60%")}>Grand Total Sales</Text>
          <Text style={{ ...styles.column("40%"), textAlign: "right" }}>{grandNetTotal}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default SalesQuantityReportPDFDocumentForDownload;